import React, { useState } from 'react';
//import '../../style/dashboard.css'; // Estilos gerais
import { Form, Button, Row, Col, Container, Alert, Nav, Navbar, Tab, Table, Modal, ButtonGroup } from 'react-bootstrap';
import FormEmail from '../../components/config/formEmail';

const Config = () => {

    const [key, setKey] = useState('email');

    return (
        <Container>
            <div className="dashboard-container">
                <Row>
                    <h2 className='text-center titulo-pagina'><i style={{ color: '#ff7a00' }} class="fas fa-cogs"></i> Configurações</h2>
                    <div className='nav-avaliacao'>
                        <Navbar expand="lg">
                            <Nav className="mr-auto">
                                <Nav.Link eventKey="email" onClick={() => setKey('email')}>Email</Nav.Link>
                            </Nav>
                        </Navbar>
                    </div>
                    <Tab.Content>
                        <Tab.Pane eventKey="email" active={key === 'email'}>
                            {key === 'email' && <FormEmail />}
                        </Tab.Pane>
                    </Tab.Content>

                </Row>
            </div>
        </Container>
    );
};

export default Config;
